/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespCollectionsModuleOld_homepage$ref = any;
export type HpRespCollectionsModuleOld_homepage = {
    readonly collectionsModule: ({
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly isLinkable: boolean | null;
        } | null> | null;
    } & ({
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly isLinkable: boolean | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespCollectionsModuleOld_homepage$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "HpRespCollectionsModuleOld_homepage",
        "type": "Homepage",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "collectionsModule",
                "name": "module",
                "storageKey": "module(type:\"collections\")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "collections"
                    }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "type": "CollectionsModule",
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "cmsId",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "link",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "imageUrl",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isLinkable",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '4e6c307404f3a7c4881db8a528ef9b23';
export default node;
